<template>
  <div>
    <dictionary-modal-table
      dictionary_link="/materials"
      title="Lista materiałów"
      :numeral_text="['materiał', 'materiały', 'materiałów']"
      :columns_title="['name']"
    ></dictionary-modal-table>
  </div>
</template>

<script>
import DictionaryModalTable from "./DictionaryModalTable.vue";
export default {
  components: {
    DictionaryModalTable,
  },
};
</script>
